import navbar from './navbar';
import banner from './banner';
import main from './main';
import footer from './footer';
console.log("inside app");

export default `
    <header>
        ${navbar} 
    </header>
    <main class="mt-auto mt-lg-0">
        ${main}
    </main>
    <footer class="mt-auto">
        ${footer}
    </footer>

`